import create from 'zustand'
import { FunctionComponent } from 'react'
import { PropsType } from 'types'

type ComponentType = FunctionComponent<React.PropsWithChildren<any>>

type OpenModalOpts<C extends ComponentType> = {
  modalProps?: PropsType<C>
  modalOptions?: object
  customModal?: boolean
}

export type ModalState = {
  modal?: ComponentType | null
  modalProps?: object
  modalOptions?: object
  customModal?: boolean
  // Modals can also use custom modals (like components/Modal/Modal.tsx) instead of Antd.Modal
  openModal: <T extends ComponentType>(modal: T, opts: OpenModalOpts<T>) => void
  closeModal: () => void
}

const useModalStore = create<ModalState>((set) => ({
  modal: null,
  modalProps: {},
  modalOptions: {},
  customModal: false,
  openModal: <C extends ComponentType>(modal: C, opts: OpenModalOpts<C>) => {
    set({ modal, ...opts })
  },

  closeModal: () => {
    set({ modal: null, modalProps: {}, modalOptions: {} })
  },
}))

export { useModalStore }
